import apiClient from '../api/client';

export interface YouTubeSearchResult {
  kind: string;
  etag: string;
  id: {
    kind: string;
    videoId: string;
  };
  snippet: {
    publishedAt: string;
    channelId: string;
    title: string;
    description: string;
    thumbnails: {
      default: { url: string; width: number; height: number };
      medium: { url: string; width: number; height: number };
      high: { url: string; width: number; height: number };
    };
    channelTitle: string;
  };
}

/**
 * Search YouTube for videos, via our own gateway.
 *
 * This used to call googleapis.com directly with `import.meta.env.VITE_YOUTUBE_API_KEY`,
 * which never worked in production: Vite inlines env vars at build time, and the
 * production build had the var empty (it was documented as coming from an Azure App
 * Setting, which a static bundle cannot read), so the key check below always threw and
 * admin song search was dead. The key now lives in Key Vault and only the server sees it.
 *
 * The response keeps YouTube's own `items` / `id.videoId` / `snippet` shape, so callers
 * did not have to change.
 */
export async function searchYouTubeVideos(
  query: string,
  maxResults: number = 5
): Promise<YouTubeSearchResult[]> {
  const params = new URLSearchParams({ q: query, maxResults: String(maxResults) });

  try {
    const response = await apiClient.get(
      `/api/organizations/youtube/search?${params.toString()}`
    );
    return response.data.items || [];
  } catch (error: any) {
    if (import.meta.env.DEV) {
      console.error('YouTube search error:', error.response?.data || error.message);
    }
    throw new Error(
      error.response?.data?.error || 'Failed to search YouTube videos'
    );
  }
}
